import forms from './forms';
import worker from './worker';
import reservedSlots from './reserved-slots';

export default {
    ...forms,
    ...worker,
    ...reservedSlots,
};
